import { Component, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { SplitButton } from 'primeng/splitbutton';

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss']
})
export class DropDownButtonComponent {
  @Input() model: MenuItem[] = [];
  @Input() label: string = '';
  @Input() icon?: string;

  @HostBinding('class')
  @Input() type: 'primary' | 'secondary' | 'simple' | 'warning' | 'danger' | 'success' = 'primary';

  @HostBinding('class.disabled') @Input() disabled = false;
  @HostBinding('class.with-icon') get hasIcon() {
    return !!this.icon;
  }

  @Output() primaryClick = new EventEmitter<PointerEvent>();

  @ViewChild(SplitButton) splitButton!: SplitButton;

  onClick(event: PointerEvent): void {
    if (this.disabled) return;
    this.splitButton.menu.toggle({ currentTarget: event.currentTarget });
  }
}
